export default __webpack_public_path__ + "static/media/Path.921d16eb.svg";